import {useMemo} from 'react';
import {Scrollbar} from 'swiper/modules';
import type {SwiperOptions} from 'swiper/types';

export const useCarouselLines = (enabled: boolean) => {
  const swiperModules = useMemo(() => (enabled ? [Scrollbar] : []), [enabled]);

  const scrollbarConfig: SwiperOptions['scrollbar'] = enabled
    ? {
        draggable: true,
      }
    : false;

  return {
    swiperModules,
    scrollbarConfig,
  };
};
